import { render, staticRenderFns } from "./BrokenRecord.vue?vue&type=template&id=642f500b&scoped=true&"
import script from "./BrokenRecord.vue?vue&type=script&lang=js&"
export * from "./BrokenRecord.vue?vue&type=script&lang=js&"
import style0 from "./BrokenRecord.vue?vue&type=style&index=0&id=642f500b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642f500b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSpacer})
